import React, { useState } from 'react'
import './navbar.css'
import { Link } from "react-router-dom"


function Navbar() {

    const [coinName, setCoinName] = useState('');
    console.log(coinName);
    // user ne search mein jo type kiya hai uski value coinname mein hai


    return (
        <div>
            <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#">Crypto<span style={{ color: "red" }}>Check</span></a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    {/* 
                    <div className="form" >
                        <form className="d-flex">
                            <input onChange={((e) => { setCoinName(e.target.value) })} className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                            <button className="btn btn-outline-success" type="submit">Search</button>
                        </form>
                    </div> */}

                    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                        <ul className="navbar-nav ">
                            <li className="nav-item">
                                <Link className="nav-link active" aria-current="page" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/coins">Crypto</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/exchange">Exchanges</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/news">News</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Navbar
